import type { AxiosPromise } from 'axios';
import BaseClient, { type ExtendedAxiosRequestConfig } from './BaseClient';
import type { CursorPaginationResponse } from './api';
import type {
    KioskSsoIdentity,
    KioskTeamSso,
    KioskTeamSsoLogin,
    KioskTeamSsoLoginsCountParams,
    KioskTeamSsoLoginsParams,
} from './adminSsoClient.types';
import type { SsoEmailDomain } from './ssoClient.types';

class AdminSsoClient extends BaseClient {
    getTeamSso(teamId: number): AxiosPromise<KioskTeamSso> {
        const url = `/api/admin/teams/${teamId}/sso`;
        return this.makeCoreApiRequest(url);
    }

    disableRequireSso(teamId: number, data: { reason: string }): AxiosPromise<{ require_sso: false }> {
        const url = `/api/admin/teams/${teamId}/sso/disable-require-sso`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    verifyEmailDomain(teamId: number, emailDomainId: number): AxiosPromise<SsoEmailDomain> {
        const url = `/api/admin/teams/${teamId}/sso/email-domains/${emailDomainId}/verify`;
        return this.makeCoreApiRequest(url, 'post');
    }

    getTeamSsoLogins(
        teamId: number,
        params?: KioskTeamSsoLoginsParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<CursorPaginationResponse<KioskTeamSsoLogin>> {
        const url = `/api/admin/teams/${teamId}/sso/logins`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getTeamSsoLoginsCount(
        teamId: number,
        params?: KioskTeamSsoLoginsCountParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<{ count: number }> {
        const url = `/api/admin/teams/${teamId}/sso/logins/count`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getUserSsoIdentities(userId: number): AxiosPromise<{ data: KioskSsoIdentity[] }> {
        const url = `/api/admin/users/${userId}/sso-identities`;
        return this.makeCoreApiRequest(url);
    }

    deleteUserSsoIdentity(userId: number, ssoIdentityId: number): AxiosPromise<void> {
        const url = `/api/admin/users/${userId}/sso-identities/${ssoIdentityId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}

export default new AdminSsoClient();
